import AccountModal from './AccountModal.view';

export default AccountModal;
